export default __webpack_public_path__ + "locales/de/Notifications.json?hash=2d24bac518c90d1d21c8c9faaddf8317";